import { Tooltip } from '@chakra-ui/react';
import type { PropsWithChildren, ReactNode } from 'react';

import tooltipStyles from '../../utilities/chart-tooltip.module.css';

type BarTooltipProps = PropsWithChildren & {
  label: ReactNode;
};

export const BarTooltip = ({ label, children }: BarTooltipProps) => {
  return (
    <Tooltip
      hasArrow
      label={label}
      padding="8px 12px"
      placement="top"
      borderRadius="4px"
      data-testid="bar-tooltip"
      className={tooltipStyles.surface}
    >
      {children}
    </Tooltip>
  );
};
